import { getISOWeekYear as o } from "./getISOWeekYear.js";
import { startOfISOWeek as a } from "./startOfISOWeek.js";
import { constructFrom as f } from "./constructFrom.js";
function n(t) {
  const e = o(t), r = f(t, 0);
  return r.setFullYear(e, 0, 4), r.setHours(0, 0, 0, 0), a(r);
}
export {
  n as default,
  n as startOfISOWeekYear
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/startOfISOWeekYear.js
// module id = 1403
// module chunks = 41